import identifyQualifiedTraffic from "@utils/identifyQualifiedTraffic";
import { handleCustomUDL } from "@utils/UDLUtils";

export class Card {
  private ctx: HTMLElement;
  private abortController = new AbortController();

  constructor(element: HTMLElement) {
    this.ctx = element;
  }

  init(): this {
    if (this.ctx.dataset.eventTracking !== "true") return this;

    const { signal } = this.abortController;
    this.ctx.addEventListener("click", (e) => {
      const card = e.currentTarget as HTMLElement;
      const customParams = card.querySelector<HTMLElement>(".data-handler")?.dataset ?? {};
      handleCustomUDL("teaser_card_button", {
        ...this.getCommonParameters(card),
        ...customParams,
      });
    }, { signal });
    return this;
  }

  private getCommonParameters(card: HTMLElement) {
    const link_url = card.querySelector<HTMLAnchorElement>("a")?.href ?? "";
    return {
      title: card.querySelector<HTMLElement>(".card-title")?.innerText ?? "",
      description: card.querySelector<HTMLElement>(".card-text")?.innerText ?? "",
      link_url,
      link_text: card.querySelector<HTMLElement>(".button")?.innerText ?? "",
      media_type: this.mediaType(card),
      ...identifyQualifiedTraffic(link_url),
    };
  }

  private mediaType(card: HTMLElement): string {
    if (card.querySelector(".comp-card-movie-overlay")) return "Movie";
    if (card.querySelector(".comp-image")) return "Image";
    return "";
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(): void {
    document
      .querySelectorAll<HTMLElement>('[data-component="card"]')
      .forEach((el) => new Card(el).init());
  }
}

